// src/logic/helpers/throwUnhandledError.ts

const normalizeThrowable = (error: unknown): Error => {
    if (error instanceof Error) return error;
    if (typeof error === "string") return new Error(error);

    try {
        return new Error(JSON.stringify(error));
    } catch {
        return new Error(String(error));
    }
};

export const throwUnhandledError = (error: unknown, context?: string): void => {
    const throwable = normalizeThrowable(error);

    if (context) {
        console.error(`[UnhandledError] ${context}`, error);
    }

    window.setTimeout(() => {
        throw throwable;
    }, 0);
};
